/**
 * @module components\ghTable\dataTable\dataRow\dataCell\dateCell
 */
import Vue from "vue";
import Component from "vue-class-component";
import DataCellBase from "../dataCellBase";

@Component
export default class DateCell extends DataCellBase {
  protected get Value() {
    let value = this.value;
    if (value) {
      try {
        let d = new Date(value);
        d.setHours(d.getHours() + 8);
        return d.toISOString().substr(0, 10);
      } catch (error) {}
    }
    return undefined;
  }
}
